<i [class]="'fa-' + variant() + ' fa-' + icon()"></i>
